import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../actions/ApiGo';
const NotificationTimes =(props)=>{
    const {t} = useTranslation()
    const [speakCount, setSpeakCount] = useState(0);
    const [speakSpeed, setSpeakSpeed] = useState(1);
    const [speed, setSpeed] = useState(1);
    const [count, setCount] = useState(0);
    const [press, setPress] = useState([false,"",""]);          // [boolen, "+"or"-", "h"or"m"]
    const [reset, setReset] = useState(true);
    useEffect(() => {
        if(!reset){return}
        ApiGo.getAlert_speak_count()
        .then(res=>{
            let _c = parseInt(String(res).split(" ")[1][0])
            let _spd = parseFloat(String(res).split(" ")[3])
            setSpeakCount(_c)
            setSpeakSpeed(_spd)
            setSpeed(_spd)
            setCount(_c)
            setReset(false)
        })
        .catch(err=>{console.log(err);})
    }, [reset]);

    function add_minus(_a_m, interval){
        let _c = 0
        if(interval===1){_c = count}
        else{_c = speed}
        if(_a_m === "+"){_c+=interval;}
        else if(_a_m === "-"){_c-=interval;}
        if(_c<=0){_c=0}
        if(interval===1){
            setCount(_c)
        }else{
            _c = Math.round((_c + Number.EPSILON) * 10) / 10;
            if(_c>=4){_c=4}
            setSpeed(_c)
        }
    }

    useEffect(()=>{
        var a
        if(!press[0]){ return }
        if(press[0]){
            a = setTimeout(()=>{
                add_minus(press[1], press[2])
            }, 150)
        }
        return ()=>{clearTimeout(a)}
    }, [press, count, speed])

    function putAlertCount(_c, _spd){
        ApiGo.putAlert_speak_count(_c, _spd)
        .then(res=>{setReset(true)})
        .catch(err=>{setReset(true)})
    }

    return(
        <div className='fx-d-c font-m bgC-white hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs'>
            <div className="font-l margl-xs h-100 margt-xxs">{t('ADMIN.VOICE_ALARM.TITLE')}</div>
            <div className='font-m margl-xs w-90'>
                {
                    t('ADMIN.VOICE_ALARM.DESCRIPTION') + ' ' +
                    t('ADMIN.VOICE_ALARM.SPEAK_COUNT') + ' : ' + speakCount + ' ' +
                    t('ADMIN.VOICE_ALARM.TIMES') + '，' + 
                    t('ADMIN.VOICE_ALARM.SPEAK_SPEED') + ' : ' + speakSpeed
                }
            </div>
            <div className='margl-xs w-60 fx-d-r fx-cfs margt-s'>
                {t("ADMIN.ADJUST_VOICE_ALARM_COUNT")}
                <div className='fx-d-r font-m w-20 fx-cspbt'>
                    <div className='w-380 fx-d-c fx-cspar h-100'>
                        <div className='tri_box admin up' onClick={()=>{add_minus("+", 1)}} onMouseDown={()=>{setPress([true,"+", 1])}} onMouseUp={()=>{setPress([false,"", 1])}}>
                            <div className='time_tri admin up' >
                                <div className='one'></div>
                                <div className='two'></div>
                            </div>
                        </div>
                        <input className='w-60 timer_inputBox admin' type='text' value={count} onChange={()=>{}} />
                        <div className='tri_box admin down' onClick={()=>{add_minus("-", 1)}}  onMouseDown={()=>{setPress([true,"-", 1])}} onMouseUp={()=>{setPress([false,"", 1])}}>
                            <div className='time_tri admin down'>
                                <div className='one'></div>
                                <div className='two'></div>
                            </div>
                        </div>
                    </div>
                </div>
                {t("ADMIN.TIMES")}

            </div>
            <div className='margl-xs w-60 fx-d-r fx-cfs margt-s'>
            {t("ADMIN.ADJUST_VOICE_SPEED")}
                <div className='fx-d-r font-m w-20 fx-cspbt'>
                    <div className='w-380 fx-d-c fx-cspar h-100'>
                        <div className='tri_box admin up' onClick={()=>{add_minus("+", 0.1)}} onMouseDown={()=>{setPress([true,"+", 0.1])}} onMouseUp={()=>{setPress([false,"", 0.1])}}>
                            <div className='time_tri admin up' >
                                <div className='one'></div>
                                <div className='two'></div>
                            </div>
                        </div>
                        <input className='w-60 timer_inputBox admin' type='text' value={speed} onChange={()=>{}} />
                        <div className='tri_box admin down' onClick={()=>{add_minus("-", 0.1)}}  onMouseDown={()=>{setPress([true,"-", 0.1])}} onMouseUp={()=>{setPress([false,"", 0.1])}}>
                            <div className='time_tri admin down'>
                                <div className='one'></div>
                                <div className='two'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='w-70 fx-d-r fx-fec margl-xs font-ml margt-xs'>
                <div className='br-10 bgC-light pad-15 l r fx-ccc shadow-xs margl-xs'
                    onClick={()=>{putAlertCount(count, speed)}}>{t('GLOBAL.CONFIRM')}</div>
            </div>
        </div>
    );

}
export default NotificationTimes;